import { Country } from '~/Api/Country';

import RequiredLicenses from './RequiredLicenses';

export default class DataSource {
	type: string;

	shortName: string;

	description: string;

	country: Country;

	requiresLicence: RequiredLicenses;

	constructor(
		type: string,
		shortName: string,
		description: string,
		country: Country,
		requiresLicence: RequiredLicenses
	) {
		this.type = type;
		this.shortName = shortName;
		this.description = description;
		this.country = country;
		this.requiresLicence = requiresLicence;
	}
}
